/**
 * MXlab — Note libre du client (panneau).
 *
 * 1. Auto-agrandissement : le textarea démarre à 2 lignes (rows=2) et grandit à la
 *    frappe jusqu'à ~6 lignes, après quoi il défile (max calculé depuis line-height).
 *
 * 2. Vide → pas de propriété : au CLIC du bouton d'ajout (capture window, avant le
 *    submit et donc avant mx-options / le natif), si le champ est vide on le DÉSACTIVE
 *    (un input désactivé n'entre pas dans la FormData), réactivé au tick suivant.
 *    Même motif que mx-bike / mx-config.
 *
 * Survie au re-rendu : le panneau n'est pas morphé au changement de variante (seul
 * <variant-picker> l'est ; mx-summary ne remplace QUE son propre fragment), donc le
 * textarea n'est jamais remplacé et sa valeur reste.
 */
class MxNote extends HTMLElement {
  connectedCallback() {
    this.field = this.querySelector('[data-mx-note-field]');
    if (!this.field) return;
    this.formId = this.field.getAttribute('form');

    this.field.addEventListener('input', () => this.autoGrow());
    this.autoGrow(); // état initial (valeur survivante éventuelle)

    // INVARIANT PANIER (dépendance temporelle) — NE PAS CASSER : désactivation d'un champ
    // note VIDE sur le CLIC (avant que la FormData ne soit lue au submit), réactivation en
    // setTimeout(0) (tâche suivante, après lecture). Ne PAS rendre ce handler async, ne PAS
    // retirer le setTimeout(0) — sinon une note vide crée une propriété panier parasite.
    this.onSubmitClick = (event) => {
      const btn = event.target.closest('button, input[type="submit"]');
      if (!btn || btn.type !== 'submit') return;
      const targetForm = btn.getAttribute('form') || (btn.form && btn.form.getAttribute('id'));
      if (targetForm !== this.formId) return;
      if (this.field.value.trim() === '') {
        this.field.disabled = true;
        setTimeout(() => {
          this.field.disabled = false;
        }, 0);
      }
    };
    window.addEventListener('click', this.onSubmitClick, { capture: true });
  }

  disconnectedCallback() {
    window.removeEventListener('click', this.onSubmitClick, { capture: true });
  }

  /** Ajuste la hauteur au contenu, plafonnée à ~6 lignes (puis défilement). */
  autoGrow() {
    const ta = this.field;
    const style = getComputedStyle(ta);
    const line = parseFloat(style.lineHeight) || 20;
    const maxH = line * 6 + parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
    ta.style.height = 'auto';
    ta.style.height = Math.min(ta.scrollHeight, maxH) + 'px';
    ta.style.overflowY = ta.scrollHeight > maxH ? 'auto' : 'hidden';
  }
}

if (!customElements.get('mx-note')) {
  customElements.define('mx-note', MxNote);
}
